import { useQuery } from '@tanstack/react-query';
import { fetchPairPeriodStatement } from '../services/dealerFundStatementPeriods';
import type { FundAccountSelection, StatementPeriod } from '../types/dealerFundStatementPeriod.types';
import { openPeriodDay, periodKey } from '../utils/statementPeriod';
import { dealerKeys } from './useDealersQuery';

export function usePairPeriodStatementQuery(
    selection: FundAccountSelection | null,
    period: StatementPeriod,
    todayIso: string,
) {
    return useQuery({
        queryKey: dealerKeys.fundStatementPeriodPair(
            selection?.sellingDealerId ?? '',
            selection?.productId ?? '',
            periodKey(period),
            openPeriodDay(period, todayIso),
        ),
        queryFn: () => fetchPairPeriodStatement(selection!.sellingDealerId, selection!.productId, period),
        enabled: selection !== null,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
    });
}
